export default class ProductImagery {
    constructor() {
        this.cacheDom()
    }

    cacheDom() {
        this.featuredImage = document.querySelector('.product-featured-image img')
    }

    updateFeaturedMedia(src) {
        this.featuredImage.src = src
        this.featuredImage.setAttribute('data-imagesrc', src)
    }
}
